
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ofertas/[...offers]",
      function () {
        return require("private-next-pages/ofertas/[...offers].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ofertas/[...offers]"])
      });
    }
  